import { useQuery } from '@dispatch/shared/hooks';
import { getTaskTemplates } from '@dispatch/shared/services';

export const useGetTemplates = ({ tenantId }: { tenantId: string }) => {
  return useQuery('templates', () => getTaskTemplates(tenantId));
};
